import { Component } from "@angular/core";
import { CommonModule, NgClass, ViewportScroller } from "@angular/common";
import {
  RouterOutlet,
  Router,
  Event,
  NavigationEnd,
  NavigationStart,
  NavigationCancel,
  NavigationError,
} from "@angular/router";
import { SidebarComponent } from "./common/sidebar/sidebar.component";
import { HeaderComponent } from "./common/header/header.component";

import { CustomizerSettingsComponent } from "./customizer-settings/customizer-settings.component";
import { CustomizerSettingsService } from "./customizer-settings/customizer-settings.service";
import { ToggleService } from "./common/sidebar/toggle.service";
import { FooterComponent } from "./common/footer/footer.component";

import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { environment } from "../environments/environment";
import { MatCardModule } from "@angular/material/card";
import { LockService } from "./services/lock.service";
import { LockScreenComponent } from "./authentication/lock-screen/lock-screen.component";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    MatProgressSpinnerModule,
    CustomizerSettingsComponent,
    MatCardModule,
    LockScreenComponent,
  ],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  // Title
  title = "Mednoc";

  // isSidebarToggled
  isSidebarToggled = false;

  // isToggled
  isToggled = false;
  currentUrl: any;
  loading!: boolean;
  locked$ = this.sessionLock.locked$;

  ngOnInit() {
    if (environment.analytics) {
      if (!document.getElementById("clarity-script")) {
        this.loadClarity();
      }

      if (!document.getElementById("ga-script")) {
        this.loadGoogleAnalytics();
      }
    }
    this.lockApp()
  }

  constructor(
    public router: Router,
    private toggleService: ToggleService,
    private viewportScroller: ViewportScroller,
    public themeService: CustomizerSettingsService,
    private sessionLock: LockService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loading = false;
        this.viewportScroller.scrollToPosition([0, 0]);
      }
    });
    // this.router.events.subscribe((event: Event) => {
    //   if (event instanceof NavigationEnd) {
    //     // Scroll to the top after each navigation end
    //     this.viewportScroller.scrollToPosition([0, 0]);
    //   }
    // });

    this.toggleService.isSidebarToggled$.subscribe((isSidebarToggled) => {
      this.isSidebarToggled = isSidebarToggled;
    });
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }


  private loadClarity() {
    if (!document.getElementById("clarity-script")) {
      const clarityScript = document.createElement("script");
      clarityScript.id = "clarity-script";
      clarityScript.type = "text/javascript";
      clarityScript.text = `
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "t605k0plh3");
      `;
      document.head.appendChild(clarityScript);
    }
  }

  private loadGoogleAnalytics() {
    if (!document.getElementById("ga-script")) {
      // Load the gtag.js script
      const gaScript = document.createElement("script");
      gaScript.id = "ga-script";
      gaScript.async = true;
      gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-923JREEVL7";
      document.head.appendChild(gaScript);

      // Initialize GA
      const gaInit = document.createElement("script");
      gaInit.id = "ga-init";
      gaInit.type = "text/javascript";
      gaInit.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-923JREEVL7');
      `;
      document.head.appendChild(gaInit);
    }
  }
  private lockApp() {
    this.sessionLock.start();

    const events = [
      'mousemove',
      'keydown',
      'click',
      'scroll',
      'touchstart'
    ];

    events.forEach(event =>
      document.addEventListener(event, () =>
        this.sessionLock.registerActivity()
      )
    );
  }
}
